import React from "react";
import { DashboardUrls } from "../constants/urls";
import DashboardLayout from "../layouts/DashboardLayout";
import ProgressBar from "react-topbar-progress-indicator";
import LazyLoading from "../components/shared/Router/LazyLoading";

const suspenseOption = {
    fallback: <ProgressBar />,
    layoutComponent: DashboardLayout,
};

const dashboardRoutes = [
    {
        path: "/:storeId" + DashboardUrls.HOME,
        layout: DashboardLayout,
        component: LazyLoading(
            () => import("./../pages/Dashboard/Home"),
            suspenseOption
        ),
    },
    {
        path: "/:storeId" + DashboardUrls.SELL,
        layout: DashboardLayout,
        component: LazyLoading(
            () => import("./../pages/Dashboard/SellList"),
            suspenseOption
        ),
    },
];

export default dashboardRoutes;
